import { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faSignOutAlt, faUser, faBars } from '@fortawesome/free-solid-svg-icons';
import './EmbeddedHeader.css';

const EmbeddedHeader = ({ toggleSidebar }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    const user = JSON.parse(localStorage.getItem('usuario'));
    const providerInfo = user?.proveedorInfo;

    // Agregar clase al body cuando el header está presente
    useEffect(() => {
        document.body.classList.add('has-embedded-header');
        return () => {
            document.body.classList.remove('has-embedded-header');
        };
    }, []);

    // Cerrar dropdown al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        window.location.href = '/loginovi';
    };

    return (
        <header className="embedded-header">
            <div className="embedded-header-content">
                {/* Botón hamburguesa - Solo móvil */}
                <button 
                    className="embedded-header-menu-toggle"
                    onClick={toggleSidebar}
                    aria-label="Toggle menu"
                >
                    <FontAwesomeIcon icon={faBars} />
                </button>

                {/* User Profile Dropdown */}
                <div className="embedded-header-user" ref={dropdownRef}>
                    <button 
                        className="embedded-header-user-button"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                        <div className="embedded-header-user-avatar">
                            {providerInfo?.logo_url ? (
                                <img 
                                    src={providerInfo.logo_url} 
                                    alt={providerInfo.nombre_empresa}
                                    className="embedded-header-avatar-img"
                                />
                            ) : (
                                <FontAwesomeIcon icon={faUser} />
                            )}
                        </div>
                        <div className="embedded-header-user-info">
                            <span className="embedded-header-user-name">
                                {providerInfo?.nombre_empresa || 'Mi Tienda'}
                            </span>
                            <span className="embedded-header-user-role">
                                {user?.nombre || 'Usuario'}
                            </span>
                        </div>
                        <FontAwesomeIcon 
                            icon={faChevronDown} 
                            className={`embedded-header-chevron ${dropdownOpen ? 'open' : ''}`}
                        />
                    </button>

                    {/* Dropdown Menu */}
                    {dropdownOpen && (
                        <div className="embedded-header-dropdown">
                            <div className="embedded-header-dropdown-header">
                                <div className="embedded-header-dropdown-avatar">
                                    {providerInfo?.logo_url ? (
                                        <img 
                                            src={providerInfo.logo_url} 
                                            alt={providerInfo.nombre_empresa}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faUser} />
                                    )}
                                </div>
                                <div className="embedded-header-dropdown-info">
                                    <p className="embedded-header-dropdown-name">
                                        {providerInfo?.nombre_empresa || 'Mi Tienda'}
                                    </p>
                                    <p className="embedded-header-dropdown-email">
                                        {providerInfo?.telefono || user?.telefono || 'Sin teléfono'}
                                    </p>
                                    <p className="embedded-header-dropdown-location">
                                        {user?.ciudad && user?.departamento 
                                            ? `${user.ciudad}, ${user.departamento}`
                                            : ''
                                        }
                                    </p>
                                </div>
                            </div>
                            
                            <div className="embedded-header-dropdown-divider"></div>
                            
                            <button 
                                className="embedded-header-dropdown-item logout"
                                onClick={handleLogout}
                            >
                                <FontAwesomeIcon icon={faSignOutAlt} />
                                <span>Cerrar Sesión</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default EmbeddedHeader;
